define(["require", "exports", "jquery", "knockout", "log", "../../utils/kendoUtils", "../../utils/tools", "../../models/UserContext", "../../shared/dataLogs", "../../models/CustomerModel", "../officeLocations/officeLocationActions", "./customerImages"], function (require, exports, $, ko, log, KendoUtils, tools, UserContext, DataLogs, CustomerModel, OfficeLocationActions, CustomerImages) {
    "use strict";
    var CustomerLocations = /** @class */ (function () {
        function CustomerLocations(customerId, customerModel, gridStructure, initGridCallback) {
            this.userCanAddLocation = ko.observable(UserContext.hasAccess("Admin,OfficeLocations.Edit,OfficeLocations.Delete"));
            this.officeLocationActions = new OfficeLocationActions();
            this.customerId = ko.observable(0);
            this.expandedItemIDs = [];
            this.selectedTabs = {};
            this.filterClearInProgress = ko.observable();
            this.filterLocationsByAny = ko.observable();
            this.editCustomerModel = ko.observable(new CustomerModel());
            var self = this;
            self.customerId(customerId);
            self.gridStructure = gridStructure;
            self.editCustomerModel = customerModel;
            self.customerImages = new CustomerImages(customerId);
            self.initExportDataSource();
            self.officeLocationActions.deleteCallback = function () {
                self.refreshTable();
            };
            self.officeLocationActions.saveCallback = function () {
                self.refreshTable();
            };
            if (initGridCallback) {
                initGridCallback(self);
            }
        }
        CustomerLocations.prototype.refreshTable = function () {
            var _a;
            var self = this;
            (_a = self.customerLocationsTable) === null || _a === void 0 ? void 0 : _a.refresh();
        };
        CustomerLocations.prototype.initGrid = function () {
            var self = this;
            self.initCustomerLocations();
            self.initLocationsMenu();
            ko.applyBindings(this, document.getElementById("divOfficesTable"));
        };
        CustomerLocations.prototype.initExportDataSource = function () {
            var self = this;
            self.locationsDataSourceOptions = {
                transport: {
                    read: {
                        url: "/CustomerLocations/GetCustomerLocations?id=" + self.customerId(),
                        type: "POST",
                        data: function () {
                            var data = {};
                            if (self.filterLocationsByAny()) {
                                data.filterText = self.filterLocationsByAny();
                            }
                            return data;
                        },
                        dataType: "json"
                    }
                },
                schema: {
                    model: self.gridStructure.model,
                    data: function (response) { return response.Data; },
                    total: "Total",
                    aggregates: "Aggregates",
                    errors: "Errors"
                },
                serverPaging: true,
                serverFiltering: true,
                serverSorting: true,
                serverAggregates: false
            };
            self.locationsDataSource = new kendo.data.DataSource(self.locationsDataSourceOptions);
        };
        CustomerLocations.prototype.initCustomerLocations = function () {
            var self = this;
            var columns = self.gridStructure.columns;
            //add actions column
            var actions = {
                field: "Actions",
                width: "170px",
                template: function (dataItem) {
                    var html = "";
                    if (dataItem.Details.IsDeleted) {
                        if (UserContext.hasAccess("Admin")) {
                            html += '<button class="btn btn-sm btn-danger btn-restore" href="#"><i class="fa fa-refresh "></i>&nbsp;Restore</button>';
                        }
                    }
                    else {
                        if (UserContext.hasAccess("Admin,OfficeLocations.Edit,OfficeLocations.Delete")) {
                            html += '<a class="btn btn-sm btn-info btn-edit" href="#"><i class="fa fa-edit "></i>&nbsp;Edit</a>';
                        }
                        if (UserContext.hasAccess("Admin,OfficeLocations.Delete")) {
                            html += '&nbsp;<button class="btn btn-sm btn-danger btn-remove" href="#"><i class="fa fa-trash-o "></i>&nbsp;Delete</button>';
                        }
                    }
                    return html;
                }
            };
            columns.push(actions);
            self.customerLocationsTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/CustomerLocations/GetCustomerLocations?id=" + self.customerId(),
                            type: "POST",
                            data: function () {
                                var data = {};
                                if (self.filterLocationsByAny()) {
                                    data.filterText = self.filterLocationsByAny();
                                }
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    schema: {
                        model: self.gridStructure.model,
                        data: function (response) { return response.Data; },
                        total: "Total",
                        aggregates: "Aggregates",
                        errors: "Errors"
                    },
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                    serverAggregates: false
                },
                gridOptions: {
                    toolbar: kendo.template($("#locations-toolbar-template").html()),
                    columns: columns,
                    detailTemplate: kendo.template($("#location-details-template").html()),
                    detailInit: self.locationDetailInit.bind(self),
                    scrollable: true,
                    height: 600,
                    dataBound: function (e) {
                        var gridData = e.sender;
                        $.each(gridData.tbody.find("tr.k-master-row"), function () {
                            var rowData = gridData.dataItem(this);
                            if (self.containsObject(self.expandedItemIDs, rowData.Id)) {
                                gridData.expandRow(this);
                            }
                        });
                    },
                    detailExpand: function (e) {
                        var rowData = e.sender.dataItem(e.masterRow);
                        if (!self.containsObject(self.expandedItemIDs, rowData.Id)) {
                            self.expandedItemIDs.push(rowData.Id);
                        }
                    },
                    detailCollapse: function (e) {
                        var rowData = e.sender.dataItem(e.masterRow);
                        for (var i = 0; i < self.expandedItemIDs.length; i++) {
                            if (self.expandedItemIDs[i] === rowData.Id)
                                self.expandedItemIDs.splice(i, 1);
                        }
                    }
                },
                gridId: "divOfficesTable",
                showPagerOnTop: true
            };
            self.customerLocationsTable.initGrid(gridOptions);
            self.filterLocationsByAny.subscribe(function () {
                if (self.filterClearInProgress()) {
                    return;
                }
                self.customerLocationsTable.refresh();
            });
            $("#divOfficesTable tbody").on("click", ".btn-add", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(this);
                self.officeLocationActions.editCustomerLocation(undefined, self.editCustomerModel().Id(), self.editCustomerModel().Name(), data.Address);
                event.preventDefault();
            }).on("click", ".btn-edit", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(this);
                self.officeLocationActions.editCustomerLocation(data.Id, self.editCustomerModel().Id(), self.editCustomerModel().Name(), data.Address);
                event.preventDefault();
            }).on("click", ".btn-remove", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(this);
                self.officeLocationActions.deleteLocationConfirm(data.Id);
                event.preventDefault();
            }).on("click", ".locationLogs", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(this);
                var dataLogs = new DataLogs("OfficeLocation", data.Id);
                dataLogs.open("Office Location logs ");
                event.preventDefault();
            }).on("click", ".btn-restore", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(this);
                self.officeLocationActions.restoreLocationConfirm(data.Id);
                event.preventDefault();
            }).on("click", ".btn-edit-comment", function (event) {
                var row = $(this).closest("tr");
                var data = row.data("dataItem");
                var tabStrip = $(".tabstrip", row).kendoTabStrip().data("kendoTabStrip");
                var contentElement = tabStrip.contentElement(tabStrip.select().index());
                var currentHeight = $(contentElement).height();
                $(this).hide();
                $(".preview", contentElement).hide();
                $(".btn-cancel-comment", contentElement).show();
                $(".btn-save-comment", contentElement).show();
                $(".editView", contentElement).show();
                $("textarea", contentElement).height(currentHeight - 35);
                $("textarea", contentElement).text(data.Details[$("textarea", contentElement).attr("name")]);
                event.preventDefault();
            }).on("click", ".btn-cancel-comment", function (event) {
                var row = $(this).closest("tr");
                var tabStrip = $(".tabstrip", row).kendoTabStrip().data("kendoTabStrip");
                var contentElement = tabStrip.contentElement(tabStrip.select().index());
                $(".btn-edit-comment", contentElement).show();
                $(".preview", contentElement).show();
                $(".btn-cancel-comment", contentElement).hide();
                $(".btn-save-comment", contentElement).hide();
                $(".editView", contentElement).hide();
                event.preventDefault();
            }).on("click", ".btn-save-comment", function (event) {
                var row = $(this).closest("tr");
                var data = row.data("dataItem");
                var tabStrip = $(".tabstrip", row).kendoTabStrip().data("kendoTabStrip");
                var contentElement = tabStrip.contentElement(tabStrip.select().index());
                $(".btn-save-comment", contentElement).button("loading");
                $(".btn-cancel-comment", contentElement).hide();
                var textArea = $("textarea", contentElement);
                var dataObj = {
                    Id: data.Id,
                    FieldName: textArea.attr("name").replace("Original", ""),
                    Value: textArea.val()
                };
                dataObj["__RequestVerificationToken"] = $('#mainCustomerForm input[name="__RequestVerificationToken"]').val();
                tools.ajaxPost({
                    url: "/OfficeLocations/SaveLocationDetailsField",
                    data: dataObj,
                    success: function (result) {
                        if (result.Success) {
                            $(".btn-save-comment", contentElement).button("reset");
                            $(".btn-edit-comment", contentElement).show();
                            $(".preview", contentElement).show();
                            $(".btn-save-comment", contentElement).hide();
                            $(".editView", contentElement).hide();
                            self.customerLocationsTable.refresh();
                        }
                    }
                }).always(function () {
                    $(".btn-save-comment", contentElement).button("reset");
                    $(".btn-cancel-comment", contentElement).show();
                });
                event.preventDefault();
            });
            var resizeTimeout = 0;
            $(window).on("resize", function (event) {
                if (resizeTimeout) {
                    clearTimeout(resizeTimeout);
                }
                resizeTimeout = setTimeout(function () {
                    log.log("resize");
                    $("textarea", "#divOfficesTable tbody").width($(".k-detail-cell", "#divOfficesTable tbody").first().width() - 100);
                }, 100);
            });
        };
        CustomerLocations.prototype.locationDetailInit = function (e) {
            var self = this;
            var currentTab = self.selectedTabs[e.data.Id];
            var detailRow = e.detailRow;
            detailRow.data("dataItem", e.data);
            self.customerImages.loadImages(e.data.Id);
            $("#customerImages" + e.data.Id).on("click", ".btn-remove-image", function (event) {
                var imageId = $(this).data("id");
                self.customerImages.deleteCustomerImageConfirm(imageId);
                event.preventDefault();
            }).on("click", ".btn-edit-image", function (event) {
                var imageId = $(this).data("id");
                self.customerImages.editCustomerImage(imageId, self.customerId());
                event.preventDefault();
            });
            var tabStrip = detailRow.find(".tabstrip").kendoTabStrip({
                animation: {
                    open: { effects: "fadeIn" }
                },
                select: function (event) {
                    self.selectedTabs[e.data.Id] = $(event.item).index();
                }
            }).data("kendoTabStrip");
            tabStrip.select(currentTab);
            setTimeout(function () {
                $("textarea", detailRow).width($(".k-detail-cell", detailRow).first().width() - 100);
            }, 1);
        };
        CustomerLocations.prototype.updateDnsDetails = function (dataList, grid) {
            var self = this;
            var gridData = dataList;
            var arrayLength = gridData.length;
            for (var i = 0; i < arrayLength; i++) {
                var item = gridData[i];
                self.getDnsDetails(item, grid);
            }
        };
        CustomerLocations.prototype.getDnsDetails = function (item, grid) {
            if (!item.DnsDetails) {
                tools.ajaxGet({
                    url: "/CustomerLocations/GetCustomerLocationDnsDetails",
                    data: {
                        locationDnsName: item.Dns,
                        hasServerInfo: item.ServerId > 0
                    },
                    success: function (result) {
                        if (result.Success) {
                            if (result.Data) {
                                if (result.Data.DnsDetails) {
                                    item.DnsDetails = result.Data.DnsDetails;
                                }
                                else {
                                    item.DnsDetails = "No Data";
                                }
                                if (!item.ServerId) {
                                    item.IpAddress = result.Data.LoginServer;
                                }
                            }
                            else {
                                item.DnsDetails = "No Data";
                            }
                        }
                        else {
                            item.DnsDetails = "No Data";
                        }
                        grid.refresh();
                    }
                });
            }
        };
        CustomerLocations.prototype.addNewCustomerLocation = function () {
            this.officeLocationActions.editCustomerLocation(undefined, this.editCustomerModel().Id(), this.editCustomerModel().Name());
        };
        CustomerLocations.prototype.clearLocationsFilter = function () {
            this.filterClearInProgress(true);
            this.filterLocationsByAny("");
            this.filterClearInProgress(false);
            this.customerLocationsTable.refresh();
        };
        CustomerLocations.prototype.expandLocationsDetails = function () {
            var self = this;
            var masterRowsExpanders = self.customerLocationsTable.getGridData().tbody.find("tr.k-master-row .k-i-expand");
            for (var i = 0; i < masterRowsExpanders.length; i++) {
                var expander = masterRowsExpanders[i];
                expander.click();
            }
        };
        CustomerLocations.prototype.initLocationsMenu = function () {
            var self = this;
            setTimeout(function () {
                var element = document.getElementById("divOfficesTable");
                $("#menu", element).kendoMenu();
                // get a reference to the menu widget
                var menu = $("#menu", element).data("kendoMenu");
                // bind to the select event
                menu.bind("select", function (e) {
                    // handle event
                    var actionName = $(e.item).data("action");
                    if (actionName) {
                        self[actionName]();
                    }
                });
            });
        };
        CustomerLocations.prototype.containsObject = function (a, obj) {
            for (var i = 0; i < a.length; i++) {
                if (a[i] === obj)
                    return true;
            }
            return false;
        };
        return CustomerLocations;
    }());
    return CustomerLocations;
});
//# sourceMappingURL=customerLocations.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/customers/customerLocations.js
// module id = 194
// module chunks = 2